import React from 'react';

export default function EightKeysModalContent() {
  return (
    <>
      <p>
        The “8 Keys to Veterans’ Success” are steps that postsecondary
        institutions can take to assist Veterans and service members in
        transitioning to higher education, completing their college programs,
        and obtaining career-ready skills.
      </p>
      <p>
        Postsecondary institutions listed here have stated their support for the
        8 Keys. However, this isn’t an assurance by the U.S. Department of
        Education that an institution has actually implemented the 8 Keys. It
        also doesn’t mean that these institutions are endorsed by the U.S.
        Department of Education.
      </p>
      <p>
        To learn more about accreditation, visit the U.S. Department of
        Education’s{' '}
        <a
          href="http://www.ed.gov/veterans-and-military-families/8-keys-success-sites"
          target="_blank"
          rel="noopener noreferrer"
        >
          8 Keys to Veterans’ Success page
        </a>{' '}
        .
      </p>
    </>
  );
}
